//dev server
export const BASE_URL = 'https://food-order.shenll.in/api/v1/user';
export const Gallery_BASE_URL = 'https://food-order.shenll.in/api/v1/user';